export default function Card({ image, title, badge }) {
  return (
    <div className="rounded-lg overflow-hidden shadow hover:shadow-lg transition bg-white dark:bg-gray-800">
      <img
        src={image}
        alt={title}
        className="w-full h-48 object-cover"
        loading="lazy"
        decoding="async"
      />
      <div className="p-4 text-center">
        <div className="flex items-center justify-center gap-2">
          <h5 className="text-lg font-semibold text-gray-800 dark:text-white">{title}</h5>
          {badge && (
            <span className="rounded-full bg-orange-500 px-2.5 py-1 text-[10px] font-black tracking-wider text-slate-950">
              {badge}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
